import * as types from '../actions/_actionTypes';
import initialState from './_initialReducerState'

export default function VerumReducer(state = initialState.verumdbi, action: any) {
  switch (action.type) {

    case types.SAVE_VERUMDBI_SUCCESS:
      return action.verumdbi;

    default:
      return state;
  }
}
